import { SlideInModal } from '@/src/common/components/SlideInModal'
import { Button } from '@/src/common/components/Button'
import { View, Text } from 'react-native'
import {
  forwardRef,
  useImperativeHandle,
  useRef,
  type ComponentProps,
  type ComponentRef,
} from 'react'
import { mesaColorNames, typography } from '@/src/common/theme'

export const CardBenefitsComponentsLearnMoreModal = forwardRef<
  ComponentRef<typeof SlideInModal>,
  React.PropsWithChildren & Pick<ComponentProps<typeof SlideInModal>, 'onClose'>
>(({ children, ...props }, ref) => {
  const bottomSheetRef = useRef<ComponentRef<typeof SlideInModal> | null>(null)
  useImperativeHandle(ref, () => bottomSheetRef.current ?? undefined)
  return (
    <SlideInModal ref={bottomSheetRef} showClose={false} {...props}>
      <View style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
        <View>
          <Text
            style={[
              { color: mesaColorNames['Greyscale/900 #152438'], textAlign: 'center' },
              typography['heading/heading3'],
            ]}
          >
            Mesa Homeowners Card Benefits
          </Text>
        </View>
        {children}
        <Button onPress={() => bottomSheetRef.current?.close()} title="Close" />
      </View>
    </SlideInModal>
  )
})
